import Vue from "vue";

//个人中心-支付状态
Vue.filter("dateFormat", value => {
  switch (value) {
    case 1:
      return "单选题";
    case 2:
      return "多选题";
    case 3:
      return "判断题";
    case 4:
      return "填空题";
    case 5:
      return "问答题";

    default:
      return value;
  }
});
Vue.filter("dateFormats", value => {
  switch (value) {
    case 1:
      return "容易";
    case 2:
      return "一般";
    case 3:
      return "较难";
    default:
      return value;
  }
});
Vue.filter("isfreeformat", value => {
  switch (value) {
    case "0":
      return "收费";
    case "1":
      return "免费";

    default:
      return value;
  }
});
Vue.filter("statusFormat", value => {
  switch (value) {
    case 0:
      return "创建中";
    case 1:
      return "待审批";
    case 2:
      return "审批通过";
    case 3:
      return "下架";
    case 4:
      return "审批不通过";

    default:
      return value;
  }
});
Vue.filter("stateFormat", value => {
  switch (value) {
    case "1":
      return "已付款";
    case "0":
      return "未付款";

    default:
      return value;
  }
});
Vue.filter("orderStateFormat", value => {
  switch (value) {
    case "1":
      return "80%";
    case "0":
      return "20%";

    default:
      return value;
  }
});
Vue.filter("courseReviewStatusFormat", value => {
  switch (value) {
    case "0":
      return "待审核";
    case "1":
      return "已审核";

    default:
      return value;
  }
});
Vue.filter("fileTypeFormat", value => {
  switch (value) {
    case 0:
      return "视频文件";
    case 1:
      return "其他文件";
    case 2:
      return "音频文件";
    default:
      return value;
  }
});
Vue.filter("alarmLevelFormat", value => {
  switch (value) {
    case 1:
      return "消息";
    case 2:
      return "警告";
    case 3:
      return "次要";
    case 4:
      return "主要";
    case 5:
      return "紧急";
    case 0:
      return "已清除";

    default:
      return value;
  }
});
Vue.filter("dateFormatStatus", value => {
  switch (value) {
    case 0:
      return "已清除";
    default:
      return "未解决";
  }
});
Vue.filter("dateFormatNotifyStatus", value => {
  switch (value) {
    case 0:
      return "禁用";
    case 1:
      return "启用";
    case 2:
      return "已发送";
    case 3:
      return "发送失败";
    case 4:
      return "已撤回";
    default:
      return "启用";
  }
});

Vue.filter("dateFormatNotifyType", value => {
  switch (value) {
    case 1:
      return "通知公告";
    case 2:
      return "个人消息";
    case 3:
      return "考试资讯";
    case 4:
      return "新闻资讯";
    case 5:
      return "企业文化";
    case 6:
      return "企业微信消息";
    default:
      return "未知类型";
  }
});
Vue.filter("dateFormatResource", resource => {
  if ("" != resource && null != resource) {
    return process.env.TEST_API + "/resource/download/" + resource.id;
  } else {
    return "";
  }
});
Vue.filter("planCourseTypeformats", value => {
  switch (value) {
    case "0":
      return "不颁发证书";
    case "1":
      return "自动颁发证书";
    case "2":
      return "手动颁发证书";
    default:
      return value;
  }
});
Vue.filter("selectiontypeformat", value => {
  switch (value) {
    case 1:
      return "判断题";
    case 2:
      return "单选题";
    case 3:
      return "多选题";
    case 4:
      return "填空题";
    default:
      return value;
  }
});
Vue.filter("courseTags", value => {
  switch (value) {
    case 1:
      return "独立课程";
    case 2:
      return "章节课程";
    // case 3:
    //   return "推荐课程";
    // case 4:
    //   return "社招课程";
    default:
      return value;
  }
});
Vue.filter("affiliatedUnitformatString", value => {
  switch (value) {
    case "":
      return "全部";
    // case "0":
    //   return "家得福-海棠店";
    // case "1":
    //   return "家得福-中央华府店";
    // case "2":
    //   return "家得福-海洲店";
    // case "3":
    //   return "家得福-西小区店";
    // case "4":
    //   return "家得福-海宁店";
    // case "5":
    //   return "家得福-百合园店";
    // case "6":
    //   return "家得福-供电局店";
    // case "7":
    //   return "家得福-水木华园店";
    default:
      return value;
  }
});
Vue.filter("affiliatedUnitformatStrings", value => {
  switch (value) {
    case null:
      return "全部";
    // case 0:
    //   return "家得福-海棠店";
    // case 1:
    //   return "家得福-中央华府店";
    // case 2:
    //   return "家得福-海洲店";
    // case 3:
    //   return "家得福-西小区店";
    // case 4:
    //   return "家得福-海宁店";
    // case 5:
    //   return "家得福-百合园店";
    // case 6:
    //   return "家得福-供电局店";
    // case 7:
    //   return "家得福-水木华园店";
    default:
      return value;
  }
});
Vue.filter("affiliatedUnitformat", value => {
  switch (value) {
    // case 0:
    //   return "家得福-海棠店";
    // case 1:
    //   return "家得福-中央华府店";
    // case 2:
    //   return "家得福-海洲店";
    // case 3:
    //   return "家得福-西小区店";
    // case 4:
    //   return "家得福-海宁店";
    // case 5:
    //   return "家得福-百合园店";
    // case 6:
    //   return "家得福-供电局店";
    // case 7:
    //   return "家得福-水木华园店";
    default:
      return value;
  }
});
Vue.filter("sexformat", value => {
  switch (value) {
    case 1:
      return "男";
    case 2:
      return "女";
    default:
      return value;
  }
});

Vue.filter("userstatusformat", value => {
  switch (value) {
    case 1:
      return "在职";
    case 2:
      return "离职";
    default:
      return value;
  }
});

Vue.filter("studyplanStatusformat", value => {
  switch (value) {
    case 1:
      return "未开始";
    case 3:
      return "已结束";
    case 2:
      return "进行中";
    default:
      return value;
  }
});
Vue.filter("studyplanPatternformat", value => {
  switch (value) {
    case 0:
      return "不颁发证书";
    case 1:
      return "自动颁发证书";
    case 2:
      return "手动颁发证书";
    default:
      return value;
  }
});
Vue.filter("examStatusformat", value => {
  switch (value) {
    case 1:
      return "未开始";

    case 2:
      return "进行中";
    case 3:
      return "已结束";
    default:
      return value;
  }
});
Vue.filter("isAllowExamformat", value => {
  switch (value) {
    case 0:
      return "暂停考试中";
    case 1:
      return "允许考试中";
    default:
      return "允许考试中";
  }
});
Vue.filter("tryOrderformat", value => {
  switch (value) {
    case 1:
      return "原始顺序";

    case 2:
      return "随机顺序";

    case 3:
      return "按题型排序";

    default:
      return value;
  }
});
Vue.filter("switchStruggleformat", value => {
  switch (value) {
    case 1:
      return "允许切换屏幕";

    case 2:
      return "不允许切换屏幕";

    default:
      return "未设置";
  }
});
Vue.filter("theSubjectShowsformat", value => {
  switch (value) {
    case 1:
      return "整页显示题目";

    case 2:
      return "单题显示";

    default:
      return value;
  }
});
Vue.filter("examStatussformat", value => {
  switch (value) {
    case 1:
      return "缺考";

    case 2:
      return "就绪";
    case 3:
      return "交卷";

    default:
      return value;
  }
});
Vue.filter("certificateStatusformat", value => {
  switch (value) {
    case 1:
      return "未申请";

    case 2:
      return "已申请";

    case 3:
      return "审批通过";

    default:
      return value;
  }
});
Vue.filter("courseReviewStatusFormats", value => {
  switch (value) {
    case 1:
      return "待审核";

    case 2:
      return "审核通过";
    case 3:
      return "审核未通过";

    default:
      return value;
  }
});
Vue.filter("datefors", value => {
  switch (value) {
    case 1:
      return "公开试题";

    case 2:
      return "考试专用试题";

    default:
      return value;
  }
});
Vue.filter("slideShowTypeformat", value => {
  switch (value) {
    case 1:
      return "PC端";

    case 2:
      return "移动端";

    default:
      return value;
  }
});

Vue.filter("is", value => {
  switch (value) {
    case 1:
      return "否";

    case 2:
      return "是";

    default:
      return value;
  }
});

Vue.filter("booleanis", value => {
  switch (value) {
    case 0:
      return "否";

    case 1:
      return "是";

    default:
      return value;
  }
});

Vue.filter("studentType", value => {
  switch (value) {
    case 1:
      return "未完成";
    case 2:
      return "未完成";
    case 3:
      return "已完成";

    default:
      return value;
  }
});

Vue.filter("dateFormattiem", function(originVal) {
  //如果没有时间默认为空
  if (originVal == null || originVal == "") {
    return "";
  }
  const dt = new Date(originVal);

  const y = dt.getFullYear();
  const m = (dt.getMonth() + 1 + "").padStart(2, "0");
  const d = (dt.getDate() + "").padStart(2, "0");

  const hh = (dt.getHours() + "").padStart(2, "0");
  const mm = (dt.getMinutes() + "").padStart(2, "0");
  const ss = (dt.getSeconds() + "").padStart(2, "0");

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
});
Vue.filter("seconddarmat", function(originVal) {
  let day = parseInt(originVal / 60 / 60 / 24);
  let hr = parseInt((originVal / 60 / 60) % 24);
  let min = parseInt((originVal / 60) % 60);
  let sec = parseInt(originVal % 60);

  return `${day}天${hr}时${min}分${sec}秒`;
});
Vue.filter("dattiem", function(time) {
  var time = time || 0;
  var h = parseInt(time / 3600),
    m = parseInt((time % 3600) / 60),
    s = parseInt(time % 60);
  h = h < 10 ? "0" + h : h;
  m = m < 10 ? "0" + m : m;
  s = s < 10 ? "0" + s : s;
  if (h == "00" && m == "00") {
    return m + ":" + s;
  } else if (h == "00" && m != "00") {
    return m + ":" + s;
  } else {
    return h + ":" + m + ":" + s;
  }
});



//////////////////
// WEBPACK FOOTER
// ./common_function/filter.js
// module id = null
// module chunks = 